<template>
  <section class="donation-page">
    <div class="bg-shape bg-shape-one"></div>
    <div class="bg-shape bg-shape-two"></div>

    <div class="donation-shell">
      <header class="hero">
        <p class="eyebrow">Support Us</p>
        <h1>Make a Donation</h1>
        <p class="subtitle">
          Your support helps us to launch this book. Use the bank details below to send your donation.
        </p>
      </header>

      <article class="transfer-card">
        <h2>Bank Transfer Details</h2>

        <div class="detail-row">
          <span class="label">Account Number</span>
          <span class="value mono">1959596772</span>
        </div>

        <div class="detail-row">
          <span class="label">Account Name</span>
          <span class="value">Royal Definition Concept Limited</span>
        </div>

        <div class="detail-row">
          <span class="label">Bank</span>
          <span class="value">Access Bank</span>
        </div>

        <button type="button" class="copy-button" @click="copyAccountNumber">
          {{ copied ? "Account Number Copied" : "Copy Account Number" }}
        </button>
      </article>
    </div>
  </section>
</template>

<script>
export default {
  name: "Donate",
  data() {
    return {
      copied: false,
    };
  },
  methods: {
    async copyAccountNumber() {
      const accountNumber = "1959596772";
      try {
        await navigator.clipboard.writeText(accountNumber);
        this.copied = true;
        window.setTimeout(() => {
          this.copied = false;
        }, 2000);
      } catch (error) {
        this.copied = false;
      }
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@400;500;700&display=swap");

.donation-page {
  position: relative;
  min-height: 100vh;
  padding: 48px 20px;
  overflow: hidden;
  font-family: "Space Grotesk", sans-serif;
  background:
    radial-gradient(circle at 10% 15%, rgba(17, 105, 71, 0.15), transparent 45%),
    radial-gradient(circle at 90% 85%, rgba(0, 122, 204, 0.2), transparent 42%),
    linear-gradient(140deg, #f5f8f7 0%, #eef5ff 100%);
}

.bg-shape {
  position: absolute;
  z-index: 0;
  border-radius: 50%;
  filter: blur(2px);
}

.bg-shape-one {
  top: -120px;
  right: -120px;
  width: 320px;
  height: 320px;
  background: rgba(0, 122, 204, 0.13);
}

.bg-shape-two {
  bottom: -100px;
  left: -100px;
  width: 280px;
  height: 280px;
  background: rgba(17, 105, 71, 0.16);
}

.donation-shell {
  position: relative;
  z-index: 1;
  max-width: 760px;
  margin: 0 auto;
}

.hero {
  text-align: center;
  margin-bottom: 24px;
}

.eyebrow {
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #116947;
  font-weight: 700;
  font-size: 0.75rem;
  margin-bottom: 8px;
}

h1 {
  margin: 0;
  font-size: clamp(1.9rem, 4vw, 3rem);
  line-height: 1.1;
  color: #102a43;
}

.subtitle {
  max-width: 640px;
  margin: 12px auto 0;
  color: #334e68;
  font-size: 1rem;
}

.transfer-card {
  background: rgba(255, 255, 255, 0.85);
  border: 1px solid rgba(16, 42, 67, 0.08);
  border-radius: 20px;
  box-shadow: 0 18px 40px rgba(16, 42, 67, 0.12);
  padding: 26px;
  backdrop-filter: blur(6px);
}

.transfer-card h2 {
  margin: 0 0 20px;
  font-size: 1.1rem;
  color: #102a43;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  padding: 14px 0;
  border-bottom: 1px dashed rgba(16, 42, 67, 0.15);
}

.detail-row:last-of-type {
  border-bottom: 0;
}

.label {
  color: #486581;
  font-size: 0.95rem;
}

.value {
  text-align: right;
  color: #102a43;
  font-weight: 700;
  font-size: 1rem;
}

.mono {
  letter-spacing: 0.05em;
}

.copy-button {
  margin-top: 18px;
  width: 100%;
  border: 0;
  border-radius: 12px;
  padding: 12px 16px;
  background: linear-gradient(120deg, #116947 0%, #007acc 100%);
  color: #fff;
  font-weight: 700;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.copy-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 10px 24px rgba(0, 122, 204, 0.25);
}

@media (max-width: 640px) {
  .donation-page {
    padding: 28px 14px;
  }

  .transfer-card {
    padding: 20px;
  }

  .detail-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
  }

  .value {
    text-align: left;
  }
}
</style>